import { useEffect, useState, useRef } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { CheckCircle2, AlertCircle } from "lucide-react";

export default function VerifyEmailPage() {
    const [params] = useSearchParams();
    const token = params.get("token");
    const { refreshUser } = useAuth();
    const [status, setStatus] = useState({ loading: true, ok: false, msg: "" });
    const ran = useRef(false);

    useEffect(() => {
        if (ran.current) return;
        ran.current = true;
        if (!token) {
            setStatus({ loading: false, ok: false, msg: "This confirmation link is missing its token." });
            return;
        }
        api.get("/auth/verify-email", { params: { token } })
            .then((r) => {
                setStatus({ loading: false, ok: true, msg: r.data.message });
                refreshUser();
            })
            .catch((err) => setStatus({ loading: false, ok: false, msg: formatApiError(err.response?.data?.detail) }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    return (
        <div className="max-w-md mx-auto px-4 py-24 text-center" data-testid="verify-email-page">
            {status.loading ? (
                <p className="font-mono text-sm text-muted-foreground animate-pulse">Confirming your email…</p>
            ) : status.ok ? (
                <div className="border-2 border-pos p-10" data-testid="verify-success">
                    <CheckCircle2 className="text-pos mx-auto" size={44} />
                    <h1 className="font-serif text-3xl font-black mt-4">Email confirmed</h1>
                    <p className="mt-3 text-sm text-muted-foreground">{status.msg}</p>
                </div>
            ) : (
                <div className="border-2 border-neg p-10" data-testid="verify-error">
                    <AlertCircle className="text-neg mx-auto" size={44} />
                    <h1 className="font-serif text-3xl font-black mt-4">Confirmation failed</h1>
                    <p className="mt-3 text-sm text-muted-foreground">{status.msg}</p>
                </div>
            )}
            <Link to="/" className="mt-8 inline-block font-mono text-xs uppercase tracking-wider text-accent">← Back home</Link>
        </div>
    );
}
